'use client'

import { useEffect, useState } from 'react'
import {
  HeaderActions,
  type HeaderDropdownKey
} from '@/components/layouts/Header/HeaderActions'

interface ButtonGroupProps {
  demoId: string
}

/** サイト共通ヘッダーの右側（お問い合わせ・資料請求）と同じ部品を使う。ログインは出さない */
export const ButtonGroup = ({ demoId }: ButtonGroupProps) => {
  const [openDropdown, setOpenDropdown] = useState<HeaderDropdownKey | null>(
    null
  )

  // 共通ヘッダーと同じく Escape で閉じる
  useEffect(() => {
    if (!openDropdown) return
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpenDropdown(null)
    }
    window.addEventListener('keydown', onKeyDown)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [openDropdown])

  return (
    <div className="hidden lg:block">
      <HeaderActions
        openDropdown={openDropdown}
        demoParams={`?from=demo&demo_id=${demoId}`}
        onOpenDropdown={setOpenDropdown}
        onCloseDropdown={() => {
          setOpenDropdown(null)
        }}
        onContactClick={() => {}}
        showLogin={false}
      />
    </div>
  )
}
